var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
var ParkingComponent = /** @class */ (function (_super) {
    __extends(ParkingComponent, _super);
    function ParkingComponent(injector, translateService) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.translateService = translateService;
        _this.translateSubscription = new Subscription();
        _this.subscription = new Subscription();
        return _this;
    }
    ParkingComponent.prototype.ngOnInit = function () {
        this.setTitle('Parcare in proiectul Dream Residence');
        this.setMetaDescription("Nu iti vei mai pune niciodata problema daca ai unde sa parchezi sau nu. Conceptul Dream Residence pune la dispozitie atat parcari subterane, cat si supraterane.");
    };
    return ParkingComponent;
}(SeoAwareBaseComponent));
export { ParkingComponent };



// WEBPACK FOOTER //
// ./src/app/parking/parking.component.ts.pre-build-optimizer.js